import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Social from '../SocialWeb/SocialWeb';
import { svgSprite, Img } from '../../../../hybrid/wrappers';
import { t } from '../../../../common/components/T';
import { rankColors } from '../../../../project/uikit/data-variables/rank-colors';
import { generateUniqueId, getStatusProgress } from '../../../../common/utils/utils';
import Display from '../../../../common/components/Display';
import css from './UserData.module.scss';

const UserData = ({ data, trans, position }) => {
    const rankColor = useMemo(() => {
        if (data.rank) {
            return rankColors[data.rank.sort] || rankColors[rankColors.length - 1];
        }
        return rankColors[0];
    }, [data]);
    const progress = useMemo(() => getStatusProgress(data?.rankData || {}), [data?.rankData]);

    return (
        <div>
            <div className={css.userModalTop}>
                <div className={css.faceBlock}>
                    {svgSprite('rounded-progress-path', {
                        className: css.progressDefault,
                        width: '122',
                        height: '122',
                        stroke: 'var(--darkColor)'
                    })}
                    {svgSprite(
                        'rounded-progress-value',
                        {
                            className: css.progressBar,
                            width: '122',
                            height: '122',
                            stroke: rankColor.color
                        },
                        'UserData',
                        [progress.dasharray, progress.dashoffset]
                    )}
                    <div className={css.userPhotoWrapper}>
                        {data?.image?.links?.preview ? (
                            <Img className={css.userAvatarStyle} src={data?.image?.links?.preview} />
                        ) : (
                            svgSprite('rank0', {
                                width: '100px',
                                height: '100px',
                                ...(data.loaded === false ? { style: { filter: 'blur(4px)' } } : {})
                            })
                        )}
                    </div>
                    {data.rank?.name || data.loaded !== false ? (
                        <div className={css.userPosition} style={{ background: rankColor.gradient }}>
                            {data.rank?.name ? data.rank.name : t('user_modal_NoRank', 'Без ранга', 'widget', trans, 'userModal')}
                        </div>
                    ) : null}
                </div>
                <div className={css.userModalTopInfo}>
                    <div className={css.userModalTopUsername}>
                        {data.activity
                            ? svgSprite('check-circle-fill', {
                                  className: css.userModalTopUsernameSvg
                              })
                            : data.loaded === false
                            ? null
                            : svgSprite('cross-circle-fill', {
                                  fill: 'var(--redColor)',
                                  className: css.userModalTopUsernameSvgRed
                              })}
                        {data.username}
                    </div>
                    <div className={css.userModalTopName}>
                        {data.full_name ? (
                            data.full_name
                        ) : (
                            <Display
                                type='fio'
                                data={{
                                    first_name: data.first_name,
                                    last_name: data.last_name,
                                    patronymic: data.patronymic
                                }}
                            />
                        )}
                    </div>
                    {data.loaded !== false || data.package?.name ? (
                        <div className={css.userModalTopStatus}>
                            <p className={css.userModalTopStatusText}>
                                {t('user_modal_package', 'Пакет', 'widget', trans, 'userModal')}:
                            </p>
                            <p>
                                {data.package?.name
                                    ? data.package.name
                                    : t('user_modal_no-package', 'Отсутствует', 'widget', trans, 'userModal')}
                            </p>
                        </div>
                    ) : null}
                </div>
            </div>
            <Social
                links={data.contacts}
                can_view_partner={data.can_view_partner || true}
                id={generateUniqueId()}
                position={position}
                trans={trans}
            />
        </div>
    );
};
UserData.propTypes = {
    nowStatus: PropTypes.string,
    username: PropTypes.string,
    fio: PropTypes.string,
    pack: PropTypes.string
};
export default UserData;
